import { call, put, takeLatest } from 'redux-saga/effects';
import {Languages} from '../api/index';
import {toast} from "react-toastify";
import {
    loadedLanguages,
    REQUEST_LANGUAGES,
    updatedLanguage,
    UPDATE_LANGUAGE,
    SEARCH_REQUEST_LANGUAGES, deletedLanguage, DELETE_LANGUAGE
} from "../actions/languages.action";

export function* requestListLanguages(payload) {
    try {
        let languages = yield call(() => Languages.all(payload));
        yield put(loadedLanguages(languages.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}
export function* updateLanguage(payload) {
    try {
        yield call(() => Languages.update(payload));
        yield put(updatedLanguage());
        toast.success('Langage mis à jour');
        // reload page
        window.location.reload();
    } catch (e) {
        let errors = e.response.data.details;
        for (e of errors) {
            toast.error(e['message']);
        }
    }
}

export function* deleteLanguage(payload) {
    try{
        yield call(() => Languages.delete(payload))
        yield put(deletedLanguage())
        toast.success('Langage supprimé');
        // reload page
        window.location.reload();
    } catch (e) {
        let errors = e.response.data.details;
        for (e of errors) {
            toast.error(e['message']);
        }
    }
}

export function* searchLanguages(payload) {
    try {
        let languages = null;
        if (payload.data.search.length > 0) {
            languages =yield call(() => Languages.search(payload.data.search));
        } else {
            languages = yield call(() => Languages.all());
        }
        yield put(loadedLanguages(languages.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}
export function* watchRequestListLanguages(){
    yield takeLatest(REQUEST_LANGUAGES, requestListLanguages);
}

export function* watchUpdateLanguage() {
    yield takeLatest(UPDATE_LANGUAGE, updateLanguage)
}

export function* watchSearchLanguages() {
    yield takeLatest(SEARCH_REQUEST_LANGUAGES, searchLanguages);
}

export function* watchDeleteLanguage() {
    yield takeLatest(DELETE_LANGUAGE, deleteLanguage)
}


// WEBPACK FOOTER //
// ./src/sagas/Languages.saga.js